import { z } from 'zod'
import { useForm } from '@src/lib/react-hook-form'
import { useNavigate } from 'react-router-dom'
import { useGlobalErrorHandler } from '@src/hooks'
import { useDispatch, userActions } from '@src/store'
import { useAuth } from '@src/hooks/useAuth'
import { useSpinner } from '@src/components/spinner'

interface LoginDto {
  /** 帳號 */
  account: string;
  /** 密碼 */
  password: string;
}

const initState: LoginDto = {
  account: '',
  password: ''
}

export function LoginViewModel() {
  const navigation = useNavigate()
  const { login } = useAuth()
  const { spinner } = useSpinner()
  const { globalErrorHandler } = useGlobalErrorHandler()
  const dispatch = useDispatch()
  
  const { register, handleSubmit, formState: { errors } } = useForm<LoginDto>({
    reValidateMode: 'onSubmit',
    defaultValues: {...initState},
    rules: z.object({
      account: z.string().nonempty({ message: '請輸入帳號' }),
      password: z.string().nonempty({ message: '請輸入密碼' })
    })
  })


  const onSubmit = async (formDto: LoginDto) => {
    try {
      const loginInfo = await spinner(login(formDto))

      dispatch(
        userActions.setUserInfo(loginInfo)
      )

      navigation('/')
    } catch (error) {
      globalErrorHandler(error)
    }
  };

  return { handleOnSubmit: handleSubmit(onSubmit), register, errors }
}

export type ILoginViewModel = ReturnType<typeof LoginViewModel>
